import React from 'react';
import {Route} from 'react-router';

export default function SignUpLayout({component: Component, ...rest}) {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <>
          <style>{'body { background-color: #fff; }'}</style>
          <div className="kt-grid kt-grid--hor kt-grid--root">
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
              <div className="kt-container">
                <Component {...matchProps} />
              </div>
            </div>
          </div>
        </>
      )}
    />
  );
}
